import { CartDrawerToggleEvent } from "@gob/events";

class ComponentCartDrawerTrigger extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector('button');
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    window.dispatchEvent(new CartDrawerToggleEvent());
  }

  connectedCallback() {
    this.button?.addEventListener('click', this.handleClick, { passive: true });
  }
}

if (!customElements.get('cart-drawer-trigger')) {
  customElements.define('cart-drawer-trigger', ComponentCartDrawerTrigger);
}